import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NEW_EPISODE_REFERENCE_DATA } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getNewEpisodeReferenceData = createAsyncThunk(
  'stop/getNewEpisodeReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(NEW_EPISODE_REFERENCE_DATA, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const newEpisodeReferenceDataSlice = createSlice({
  name: 'stop/newEpisodeReferenceDataSlice',
  initialState: null,
  reducers: {
    resetNewEpisodeReferenceData: () => null,
  },
  extraReducers: {
    [getNewEpisodeReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetNewEpisodeReferenceData } =
newEpisodeReferenceDataSlice.actions;

export default newEpisodeReferenceDataSlice.reducer;
